lb4p = {
  prevX: null,
  init: function() {
    this.prevX = window.innerWidth;
    lb4p.faq();
    lb4p.resize();
    lb4p.triggerEvents();
    lb4p.collapsible();
    lb4p.parallax.init();
    lb4p.infiniteScroll.init();
    lb4p.articleCollection.init();
    setTimeout(function () { lb4p.feefoProducts.init(); }, 1000);
  },
  faq: function() {
    var coll = document.getElementsByClassName("faq-collapsible");
    var i;
    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("faq-collapsible-active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        } 
      });
    }
  },
  searchMove: function (x){
    var drawer = document.getElementById("SearchDrawer");
    var mobile = document.getElementById("SearchMob"); 
    var desk = document.getElementById("SearchDesk");
    if (drawer != null && mobile != null && desk != null ) {
      if (x < 750 || mobile.innerHTML == null) {
        drawer.classList.add('drawer','drawer--top');
        mobile.appendChild(drawer);
      } else if (x >= 750 || desk.innerHTML == null) {
        drawer.classList.remove('drawer','drawer--top');
        desk.appendChild(drawer);
      }
    }
  },
  resize: function(evt) {
    var x = window.innerWidth;
    if (x != this.prevX) {
      lb4p.searchMove(x);
    }
    this.prevX = x;
  },
  updatePrice: function() {
    var cartContents = fetch('/cart.js')
    .then(response => response.json())
    .then(data => { return data });
    cartContents.then(function(result) {
      var cartCost = document.getElementById("CartCost");
      if (cartCost != null) {
        var cartIntro = cartCost.innerHTML.substring(0,8);
        cartCost.innerHTML = cartIntro + (result['total_price']/100).toFixed(2);
    }
    }, function(err) {
      console.log(err);
    });
  },
  scrollTo: function(elem) {
    elem.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
  },
  triggerEvents: function(){
    var moreScroll = document.getElementById("moreScroll");
    var collectionInfo = document.getElementById("CollectionInfo");
    if (moreScroll != null && collectionInfo != null) {
      moreScroll.addEventListener("click",function(){lb4p.scrollTo(collectionInfo)});
    }
    var cartCount = document.getElementById("CartItemCount");
    if (cartCount != null) {
      var observer = new MutationObserver(function(mutations) {
        lb4p.updatePrice();   
      });
      var config = { attributes: true, childList: true, characterData: true };
      observer.observe(cartCount, config);
    }
  },
  collapsible:function () {
    var coll = document.getElementsByClassName("collapsible");
    var i;
    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("collapsible-active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        } 
      });
    }
    var defOpen = document.getElementById("defaultOpen");
    if (defOpen != null) {
      defOpen.style.maxHeight = defOpen.scrollHeight + "px";
    }
  },
  parallax: {
    elements: null,
    tick: false,
    init: function()
    {
      this.elements = document.querySelectorAll(".lb4p_hero_parallax");
      if (this.elements != null && this.elements.length > 0) {
        this.elements.forEach(this.checkPos);
      }
    },
    scroll: function() {
      if (this.elements != null && this.elements.length > 0) {
        this.elements.forEach(this.checkPos);
      }
    },
    checkPos: function (item, index, arr) {
      var tmp = item.querySelectorAll('.lb4p_hero_image_desk'); 
      var tmp2 = item.querySelectorAll('.lb4p_hero_image_mobile'); 
      if (window.innerWidth <= 749) {
        var calc = item.getBoundingClientRect().top / 12;
      } else {
        var calc = item.getBoundingClientRect().top / 8;
      }
      if (tmp != null && tmp.length > 0) {
        if (item.getBoundingClientRect().top < (window.innerHeight + item.clientHeight) && item.getBoundingClientRect().top > (0 - item.clientHeight) && calc < 100) {
          tmp[0].style.objectPosition = "50% " + calc + "%";
          if (tmp2 != null && tmp2.length > 0) {
            tmp2[0].style.objectPosition = "50% " + calc + "%";
          }
        }
      }
    }
  },
  infiniteScroll: {
    productTop: null,
    productContainer: null,
    pagination: null,
    loading: null,
    request: null,
    lastRequestURL: null,
    tick: false,
    init: function()
    {
      this.pagination = document.querySelector(".lb4p_infinite");
      if (this.pagination) {
        this.productTop = document.querySelector(".lb4p_infinite_top");
        this.productContainer = document.querySelector(".lb4p_infinite_container");
        this.loading = document.querySelector(".lb4p_loading");
        this.loading.style.display = "none";
        this.ticking = false;
      }
    },
    scroll: function() {
      if (this.pagination != null) {
        if (!this.ticking) {
          if (this.pagination.getBoundingClientRect().bottom < window.innerHeight && this.pagination.getBoundingClientRect().bottom > 0) {
            if (parseInt(this.pagination.dataset.currentPage) < parseInt(this.pagination.dataset.totalPages)) {
              this.ticking = true;
              lb4p.infiniteScroll.loadNext();
              this.loading.style.display = "block";
              this.pagination.dataset.currentPage = parseInt(this.pagination.dataset.currentPage) + 1;
            }
          }
        }
      }
    },
    loadNext: function() {
      this.request = new XMLHttpRequest();
      this.request.responseType = "document";
      if (lastRequestURL = this.pagination.dataset.nextUrl && 
          this.ticking) {
        this.lastRequestURL = this.pagination.dataset.nextUrl;
        this.request.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
              lb4p.infiniteScroll.addItems(this.response);
           }
         };
        this.request.open("GET", this.pagination.dataset.nextUrl);
        this.request.send();
       }
    },
    addItems: function(response) {
      this.productContainer.innerHTML += response.querySelector('.grid--view-items').innerHTML;
      this.productTop.replaceChild(response.querySelector('.lb4p_infinite'), this.pagination);
      this.pagination = this.productTop.querySelector('.lb4p_infinite');
      this.loading.style.display = "none";
      this.ticking = false;
      this.feefoRefresh();
    },
    feefoRefresh: function() {
      var feefo = document.getElementById('lb4p_feefo');
      if (feefo != null) {
        !function(b){var a=document.createElement("script");a.setAttribute("async","async"),a.setAttribute("src","//register.feefo.com//feefo-widget-v2/js/feefo-widget.js"),a.setAttribute("type","text/javascript"),a.onload=function(){void 0===b.feefoWidgetInstance&&"undefined"!=typeof feefoWidget&&(b.feefoWidgetInstance=feefoWidget(b.feefoWidgetInstanceConfig))},b.feefoWidgetInstanceConfig={assetUrl:"//register.feefo.com//feefo-widget-v2",debug:!1,hosts:{api:"api.feefo.com/api",widget:"register.feefo.com",collector:"collect.feefo.com"},merchantId:"life-before-plastic",protocol:"https",source:"javascript",tags:"",externalCta:"",versionDir:"feefo-widget-v2",isMigratedMerchant:"false"},document.head.appendChild(a)}(window)
      }
    }
  },
  feefoProducts: {
    widget: null,
    init: function() {
      this.widget = document.getElementById('feefo-product-review-widgetId');
      if (this.widget != null) {
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        var observer = new MutationObserver(lb4p.feefoProducts.change);
        observer.observe(this.widget.shadowRoot, {childList: true});
        console.log("watching");
        console.log(this.widget);
        this.change();
      }
    },
    change: function() {
        console.log(this.widget);
        console.log("applying");
        var sheet = new CSSStyleSheet();
        sheet.replaceSync( `.on-page-container, .on-page-container.mobile .on-page-summary-header-wrapper { padding: 0px !important; } .on-page-container .on-page-body .on-page-comments { margin-left: 0px; }`);
        this.widget.shadowRoot.adoptedStyleSheets = [ sheet ];
        console.log("applied");
    }
  },
  articleCollection: {
    init: function() {
      var featuredStart = document.getElementById("lb4pFeaturedStart");
      var featured = document.getElementById("lb4pFeatured");
      if (featuredStart != null && featured != null) {
        var rteNode = document.querySelector(".rte");
        var rteNew = document.createElement("div");
        var refNode = featured;
        while (refNode.nextSibling) {
          rteNew.appendChild(refNode.nextSibling);
        }
        rteNode.parentNode.insertBefore(refNode, rteNode.nextSibling);
        refNode.parentNode.insertBefore(rteNew, refNode.nextSibling);
        rteNew.className = "rte";
        featured.replaceWith(featuredStart);
      }
    }
  }
}

if(window.addEventListener) {
  window.addEventListener('load',lb4p.init,false);
  window.addEventListener('resize',lb4p.resize,false);
  window.addEventListener('orientationchange',lb4p.resize,false);
} else if(window.attachEvent) {
  window.attachEvent('onload',lb4p.init); //IE
}
window.addEventListener('scroll', function() { lb4p.infiniteScroll.scroll() });
window.addEventListener('scroll', function() { lb4p.parallax.scroll() });
window.addEventListener('touchmove', function() { lb4p.parallax.scroll() });